module.exports = __webpack_public_path__ + "img/rockestate-logo-horizontal-dark.9b276b41.svg";